import {
    cilLockLocked,
    cilLockUnlocked,
    cilUser,
    cilSun,
    cilMoon,
    cilSpeedometer,
    cilSettings,
    cilShieldAlt,
    cilStorage,
    cilChart,
    cilTags,
    cilLayers,
    cilCloudUpload,
    cilCloudDownload,
    cilLoopCircular,
    cilUserX,
    cilFlagAlt
} from '@coreui/icons'
import { logo } from "./logo";
import { eye } from "./js/eye";
import { sponsors } from "./js/sponsors";
import { documentation } from "./js/documentation";
import { eraser } from "./js/eraser";
import { leads } from "./js/leads";
import { outputs } from "./js/outputs";
import { layer } from "./js/layer";
import { birthdayIcon } from "./js/birthdayIcon";
import { genderIcon } from "./js/genderIcon";
import { privacyIcon } from "./js/privacyIcon";
import { progressBarStepsIcon } from "./js/progressBarStepsIcon";
import { progressBarPercentIcon } from "./js/progressBarPercentIcon";





export const iconsSet = Object.assign({}, { logo, eye, sponsors, documentation, eraser, leads, outputs, layer, birthdayIcon, genderIcon, privacyIcon, progressBarStepsIcon, progressBarPercentIcon }, {
    cilLockLocked,
    cilLockUnlocked,
    cilUser,
    cilSun,
    cilMoon,
    cilSpeedometer,
    cilSettings,
    cilShieldAlt,
    cilStorage,
    cilChart,
    cilTags,
    cilLayers,
    cilCloudUpload,
    cilCloudDownload,
    cilLoopCircular,
    cilUserX,
    cilFlagAlt
}, {}, {});
